module.exports = __webpack_public_path__ + "static/corgi-8ba3e87de3ebf98558fdae1aa0ebd856.mp4";